import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

interface StatCardProps {
  title: string;
  value: string | number;
  change?: number;
  icon: React.ReactNode;
  iconColor: string;
}

export default function StatCard({ title, value, change, icon, iconColor }: StatCardProps) {
  return (
    <div className="bg-white rounded-card shadow-card p-6">
      <div className={`w-10 h-10 rounded-xl flex items-center justify-center mb-4 ${iconColor}`}>
        {icon}
      </div>
      <p className="text-[32px] font-bold text-text-primary leading-tight">{value}</p>
      <div className="flex items-center gap-2 mt-1">
        <p className="text-xs text-text-hint">{title}</p>
        {change !== undefined && (
          <span
            className={`inline-flex items-center gap-0.5 text-[11px] font-semibold ${
              change >= 0 ? 'text-green-600' : 'text-red-500'
            }`}
          >
            {change >= 0 ? (
              <TrendingUp className="w-3 h-3" />
            ) : (
              <TrendingDown className="w-3 h-3" />
            )}
            {change >= 0 ? '+' : ''}
            {change}%
          </span>
        )}
      </div>
    </div>
  );
}
